import { forwardRef } from 'react';
import { Add16, ChevronDown24 } from 'ui/icons';
import { SecondaryButton, BUTTON_SIZES } from 'ui/button';
import { Tooltip, TipPlacement } from 'ui/tooltip';
import { useTranslation } from 'modules/segmentation/hooks';

type InsightSelectTriggerProps = {
  toggleDropdown: () => void;
  isDisabled: boolean;
  placeholder?: string;
};

export const testIds = {
  button: 'insight-select-button-trigger',
  display: 'insight-select-value-display',
};

export const Trigger = forwardRef<HTMLButtonElement, InsightSelectTriggerProps>(
  ({ toggleDropdown, isDisabled, placeholder = '' }, ref) => {
    const { t } = useTranslation();
    const TOOLTIP_TEXT = t('insights.select.tooltip');

    return (
      <Tooltip isEnabled={isDisabled} tooltipContent={TOOLTIP_TEXT} placement={TipPlacement.Left}>
        <SecondaryButton
          ref={ref}
          onClick={toggleDropdown}
          isDisabled={isDisabled}
          data-test={testIds.button}
          size={BUTTON_SIZES.LARGE}
        >
          <Add16 />
          <span data-test={testIds.display}>{placeholder}</span>
          <ChevronDown24 />
        </SecondaryButton>
      </Tooltip>
    );
  },
);
